<template>
    <div class="space-y-1">
        <div>
            <FieldLabel :field="field"/>
            <div class="text-gray-600 text-xs font-normal">
                Please enter your 10-digit phone number
            </div>
            <FieldInstructions v-if="field.instructions_position !== 'below'" :field="field" />
        </div>

        <div class="w-full flex mt-1 rounded-md shadow-sm border border-gray-700 overflow-hidden focus-within:border-primary-500 focus-within:ring-2 focus-within:ring-primary-500">
            <input
                type="tel"
                class="w-full field-custom field-in-group"
                :id="field.id"
                :name="field.handle"
                :placeholder="field.placeholder"
                :title="field.label || field.placeholder"
                :aria-label="field.label || field.placeholder"
                :value="value"
                :required="field.isRequired"
                :autocomplete="field.autocomplete !== 'n/a' ? field.autocomplete : undefined"
                :readonly="field.visibility === 'read_only'"
                maxlength="14"
                @keyup="onKeyUp"
            />
        </div>

        <FieldInstructions v-if="field.instructions_position === 'below'" :field="field" />
    </div>
</template>

<script setup>
import {ref} from "vue";
import FieldInstructions from "../FieldInstructions.vue";
import FieldLabel from "../FieldLabel.vue";
import {defineField} from "./BaseField.js";

const field = defineField();

const value = ref(field.old);

function onKeyUp(event) {
    const digits = event.target.value.replace(/\D/g, '');

    if (digits.length === 0) {
        value.value = '';
        return;
    }

    let newVal = '(' + digits.substring(0,3);

    if (digits.length >= 3) {
        newVal += ') ' + digits.substring(3,6);
    }

    if (digits.length >= 6) {
        newVal += '-' + digits.substring(6,10);
    }

    value.value = newVal;
}
</script>
